export default "assets/images/menu-texture-c92c5d53.jpg";